module.exports = "../../app/cells/components/banner/banner_damasio_cell.rb";